import { compose, withPropsOnChange, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { get } from 'lodash';
import config from '../../config';
import { nullFunc } from '../utils/helpers';
import { setInstantExperiences, setInstantExperiencesOwner } from './actions';
import { getShopByRoute } from '../shops/selectors';
import { getBarberByRoute } from '../barbers/selectors';
import { getInstantExperiences, getInstantExperiencesOwner } from './selectors';
import { getExtension } from '../extensions';
import FBPixel from '../applicationServices/analytics/fbPixel';
import withConsent from '../applicationServices/analytics/fbPixel/withConsent';

const InstantExperiences = compose(
  withRouter,
  connect(
    (state, ownProps) => {
      const owner = getInstantExperiencesOwner(state);
      let pixelId;
      const { brandRoute, shopRoute, barberRoute } = ownProps.params;
      switch (owner) {
        case 'brand': {
          const extension = getExtension(state, brandRoute);
          pixelId = get(extension, 'pixelId', null);
          break;
        }
        case 'shop': {
          const shop = getShopByRoute(state, shopRoute);
          pixelId = get(shop, 'pixelId', null);
          break;
        }
        case 'barber': {
          const barber = getBarberByRoute(state, barberRoute);
          pixelId = get(barber, 'pixelId', null);
          break;
        }
        default: {
          pixelId = null;
          break;
        }
      }

      return {
        pixelId,
        instantExperiencesOwner: owner,
        instantExperiences: getInstantExperiences(state),
      };
    },
    { setInstantExperiences, setInstantExperiencesOwner }
  ),
  lifecycle({
    componentDidMount() {
      this.props.setInstantExperiences(this.props.location.query.ig_ix);
      // Since we changed parameter name at one point on API we need to check both old and new query param
      this.props.setInstantExperiencesOwner(this.props.location.query.ig_ix_owner || this.props.location.query.owner);
    },
  }),
  withConsent,
  withHandlers({
    initDeprecatedIgIx: props => () => {
      props.setInstantExperiences(props.instantExperiences);
      if (!props.instantExperiences) return;
      FBPixel.init(true);
      FBPixel.setPixelFor('instantExperience', config.fbPixel);
      FBPixel.trackPageView('instantExperience');
      if (window.extAsyncInit && window.extAsyncInit.hasRun) {
        FBPixel.initExtensions();
      } else {
        window.extAsyncInit = FBPixel.initExtensions;
      }
    },
  }),
  withPropsOnChange(
    ['pixelId', 'instantExperiences'],
    (props) => {
      if (props.instantExperiences && !props.instantExperiencesOwner) {
        props.initDeprecatedIgIx();
        return;
      }

      if (!props.pixelId || !props.instantExperiences) {
        FBPixel.setPixelFor('instantExperience', null);
        return;
      }

      FBPixel.setPixelFor('instantExperience', props.pixelId);
      FBPixel.trackPageView('instantExperience');
    }
  )
)(nullFunc);

export default InstantExperiences;



// WEBPACK FOOTER //
// ./src/app/instantExperiences/InstantExperiences.js